export function BrandLockup({ compact = false }: { compact?: boolean }) {
  return (
    <div
      aria-label="Bomia by Shud"
      className={`brand-lockup ${compact ? "brand-lockup--compact" : ""}`}
      role="img"
    >
      <img alt="" className="brand-lockup__bomia" src="/brand/bomia.svg" />
      <span className="brand-lockup__by">by</span>
      <span className="brand-lockup__shud"><img alt="" src="/brand/shud.svg" /></span>
    </div>
  );
}
